import { render, staticRenderFns } from "./ManagerPage.vue?vue&type=template&id=2f5c6d9c&scoped=true&"
import script from "./ManagerPage.vue?vue&type=script&lang=js&"
export * from "./ManagerPage.vue?vue&type=script&lang=js&"
import style0 from "./ManagerPage.vue?vue&type=style&index=0&id=2f5c6d9c&lang=less&scoped=true&"
import style1 from "./ManagerPage.vue?vue&type=style&index=1&id=2f5c6d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c6d9c",
  null
  
)

export default component.exports